import request from './request';

export default {
	async getCaterers() {
		const res = await request.get('/app/rating/caterers');
		return res;
	},
	async createRatingResponse(body) {
		const res = await request.post('/app/rating', body);
		return res;
	}
};
